import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navItems = [
  { label: "首页", path: "/" },
  { label: "使用指南", path: "/category/usage-guide" },
  { label: "最新动态", path: "/category/latest-news" },
  { label: "常见问题", path: "/category/faq-help" },
  { label: "关于我们", path: "/about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === "/";

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className={`flex items-center gap-2 font-heading text-xl font-bold whitespace-nowrap cursor-pointer ${
              scrolled || !isHome ? "text-foreground-950" : "text-white"
            }`}
          >
            <span className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold ${
              scrolled || !isHome ? "bg-primary-500 text-white" : "bg-white/20 text-white"
            }`}>
              17
            </span>
            17c一起草
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navItems.map((item) => {
              const isActive =
                item.path === "/"
                  ? location.pathname === "/"
                  : location.pathname.startsWith(item.path);
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap cursor-pointer transition-all duration-200 ${
                    isActive
                      ? scrolled || !isHome
                        ? "bg-primary-100 text-primary-700"
                        : "bg-white/20 text-white"
                      : scrolled || !isHome
                        ? "text-foreground-700 hover:bg-background-200"
                        : "text-white/80 hover:text-white hover:bg-white/10"
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#entrance"
              className={`px-5 py-2 rounded-full text-sm font-semibold whitespace-nowrap cursor-pointer transition-all duration-200 ${
                isHome && !scrolled
                  ? "bg-white text-primary-600 hover:bg-white/90"
                  : "bg-primary-500 text-white hover:bg-primary-600"
              }`}
            >
              进入官网
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer ${
              scrolled || !isHome ? "text-foreground-950" : "text-white"
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navItems.map((item) => {
              const isActive =
                item.path === "/"
                  ? location.pathname === "/"
                  : location.pathname.startsWith(item.path);
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`px-4 py-3 rounded-lg text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                    isActive
                      ? "bg-primary-100 text-primary-700"
                      : "text-foreground-700 hover:bg-background-200"
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
            <a
              href="#entrance"
              className="px-4 py-3 rounded-lg text-sm font-semibold bg-primary-500 text-white text-center whitespace-nowrap cursor-pointer mt-2"
            >
              进入官网
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}